import React, { useState } from "react";
import { Menu, MenuItem, MenuAnchor, MenuDivider } from "@cdk-uip/react-menu";
import { Icon } from "@cdk-uip/react-icon";
import { CANDIDATE_STATUS } from "../../constants/constants";
import edit from "../../images/edit-account.svg";
import "../../styles/styles.css";

const VerticalContextMenu = ({
  statusId,
  cloudDownload,
  deleteCandidate,
  editOnboardingPdf,
  sendEmail,
  sendOnboardingInvitation,
  viewOnboardingPdf,
  setShowITSetup
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isDisable = statusId < CANDIDATE_STATUS.ONBOARDING.id;
  return (
    <MenuAnchor className="d-inline-block">
      <Icon className="on-hover" onClick={() => setIsOpen(true)}>
        more_vert
      </Icon>
      <Menu
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        onSelected={selected => setIsOpen(false)}
        className="position-absolute rounded"
      >
        <MenuItem
          className="font-weight-bold h-25"
          onClick={sendOnboardingInvitation}
          disabled={statusId < CANDIDATE_STATUS.SUBMITTED.id}
        >
          <Icon className="vertical-more-menu-icon">check_circle</Icon>
          Send Onboarding Invitation
        </MenuItem>
        <MenuDivider />
        <MenuItem
          disabled={isDisable}
          className="font-weight-bold h-25"
          onClick={editOnboardingPdf}
        >
          <img
            src={edit}
            height="30px"
            alt="edit"
            className={
              isDisable ? "context-menu-icon-disable" : "context-menu-icon"
            }
          />
          Edit Onboarding Form
        </MenuItem>
        <MenuDivider />
        <MenuItem
          disabled={isDisable}
          className="font-weight-bold h-25"
          onClick={viewOnboardingPdf}
        >
          <Icon className="vertical-more-menu-icon">picture_as_pdf</Icon>
          View Onboarding Pdf
        </MenuItem>
        <MenuDivider />
        <MenuItem
          disabled={isDisable}
          className="font-weight-bold h-25"
          onClick={cloudDownload}
        >
          <Icon className="vertical-more-menu-icon">cloud_download</Icon>
          Download Onboarding Pdf
        </MenuItem>
        <MenuDivider />
        <MenuItem className="font-weight-bold h-25" onClick={setShowITSetup}>
          <Icon className="vertical-more-menu-icon">laptop_mac</Icon>
          Information for IT Team
        </MenuItem>
        <MenuDivider />
        <MenuItem className="font-weight-bold h-25" onClick={sendEmail}>
          <Icon className="vertical-more-menu-icon">email</Icon>
          Send Email
        </MenuItem>
        <MenuDivider />
        <MenuItem className="font-weight-bold h-25" onClick={deleteCandidate}>
          <Icon className="vertical-more-menu-icon">delete</Icon>
          Delete User
        </MenuItem>
      </Menu>
    </MenuAnchor>
  );
};

export default VerticalContextMenu;
